export function InlineForm({
  placeholder,
  value,
  onChange,
  cta,
  onSubmit,
  busy,
  error
}: {
  placeholder: string;
  value: string;
  onChange: (v: string) => void;
  cta: string;
  onSubmit: () => void;
  busy?: boolean;
  error?: string;
}) {
  return (
    <div className="mt-3">
      <div className="flex gap-2">
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          onKeyDown={(e) => {
            if (e.key === 'Enter') onSubmit();
          }}
          className="h-11 flex-1 rounded-[13px] border border-black/10 bg-card px-4 text-[14px] font-medium text-ink outline-none placeholder:text-ink3 focus:border-accent"
        />
        <button
          type="button"
          disabled={busy}
          onClick={onSubmit}
          className="tap rounded-[13px] bg-night px-5 text-[14px] font-extrabold text-white disabled:opacity-60"
        >
          {busy ? '…' : cta}
        </button>
      </div>
      {error && <div className="mt-2 text-[12px] font-semibold text-danger">{error}</div>}
    </div>
  );
}
